import React, { memo } from 'react';

import barnOwlClient, { CreateBarnOwlAccountDto } from 'clients/barnOwl';
import BackOfficeBarnOwlFormDrawer from 'components/drawers/BackOfficeBarnOwlFormDrawer';
import BarnOwlCreateFormItems from 'components/forms/BarnOwlCreateFormItems';
import { SEARCH_PARAMS } from 'constants/search-params';

type BarnOwlCreateFormValues = CreateBarnOwlAccountDto & {
  enterpriseId: number;
};

function BackOfficeBarnOwlCreateDrawer(): JSX.Element {
  return (
    <BackOfficeBarnOwlFormDrawer<BarnOwlCreateFormValues>
      drawerValue={SEARCH_PARAMS.DRAWER.values.CREATE_BARN_OWL_ACCOUNT}
      title="Create Barn Owl account"
      footerLabel="Create account"
      submit={async ({ enterpriseId, ...accountFields }) => {
        const response = await barnOwlClient.createBarnOwlAccount(
          Number(enterpriseId),
          accountFields
        );
        if (response.error) {
          return { error: response.error.message || 'Unable to create Barn Owl account' };
        }
        return {
          successMessage: `Created Barn Owl account ${response.data?.email ?? ''}`.trim()
        };
      }}
    >
      <BarnOwlCreateFormItems />
    </BackOfficeBarnOwlFormDrawer>
  );
}

export default memo(BackOfficeBarnOwlCreateDrawer);
